/* eslint-disable no-console */
import {MixPanelKey,MixPanelDebug} from '../config'
import localStorage from '../browser/local-storage'
import {canUseDOM} from '../app/exec-env'
const mixpanel = canUseDOM ? require(`mixpanel-browser`) : null

let enabled = false
let debug = MixPanelDebug
let loaded = false
let distinct_id = null
const callbacks_get_distinct_id = []

export const init = callback => {
  if (MixPanelKey == null) {
    if (callback != null) callback(null)
    return
  }
  try {
    mixpanel.init(MixPanelKey, {
      persistence: `localStorage`, // just as good or better than cookies!?
      'track_pageview': false, // don't automatically add a page view on load
      loaded: () => {
        distinct_id = mixpanel.get_distinct_id()
        loaded = true
        if (debug) console.log(`mix panel loaded with id ${distinct_id} ${JSON.stringify(arguments)}`)
        const stored_distinct_id = localStorage.getItem(`distinct_id`)
        if (stored_distinct_id != null && stored_distinct_id != distinct_id) console.log(`mixpanel distinct_id ${distinct_id} versus localStorage ${stored_distinct_id}`)
        if (callback != null) callback(distinct_id)
        callbacks_get_distinct_id.forEach(callback => callback(distinct_id))
      },
    })
    enabled = true
  }
  catch(e) {
    console.log(`mixpanel.init exception ${e.message}`)
  }
}

export const set_debug = value => {
  debug = value
}

export const track = (name, data, callback) => {
  if (debug) console.log(`mixpanel track ${name} ${JSON.stringify(data)}`)
  if (!enabled) return
  try {
    mixpanel.track(name, data, () => {
      if (debug) console.log(`track callback arguments: ${JSON.stringify(arguments)}`)
      if (typeof(callback) === `function`) callback.apply(this, arguments)
    })
  }
  catch(e) {
    console.log(`mixpanel.track exception ${e.message}`)
  }
}

export const log_error = data => {
  if (debug) console.log(`mixpanel log error ${JSON.stringify(data)}`)
  if (!enabled || data == null) return
  if (typeof(data) === `string`) data = {name: data}
  data.page = window.location.pathname
  try {
    mixpanel.track(`errors`, data)
  }
  catch(e) {
    console.log(`mixpanel.track exception ${e.message}`)
  }
}

export const time_event = name => {
  if (!enabled) return
  try {
    mixpanel.time_event(name)
  }
  catch(e) {
    console.log(`mixpanel.time_event exception ${e.message}`)
  }
}

export const register = (data, days) => {
  if (!enabled) return
  try {
    mixpanel.register(data, days)
  }
  catch(e) {
    console.log(`mixpanel.register exception ${e.message}`)
  }
}

export const register_once = (data, days) => {
  if (!enabled) return
  try {
    mixpanel.register_once(data, days)
  }
  catch(e) {
    console.log(`mixpanel.register_once exception ${e.message}`)
  }
}

export const unregister = name => {
  if (!enabled) return
  try {
    mixpanel.unregister(name)
  }
  catch(e) {
    console.log(`mixpanel.unregister exception ${e.message}`)
  }
}

export const identify = unique_id => {
  if (debug) console.log(`mixpanel identify ${unique_id}`)
  if (!enabled) return
  try {
    mixpanel.identify(unique_id)
  }
  catch(e) {
    console.log(`mixpanel.identify exception ${e.message}`)
  }
}

export const ignore = () => {
  register({ignore: true})
}

export const unignore = () => {
  unregister(`ignore`)
}

// clears all mixpanel data --for hard user logout
export const reset = () => {
  if (!enabled) return
  try {
    mixpanel.reset()
  }
  catch(e) {
    console.log(`mixpanel.reset exception ${e.message}`)
  }
}

export const get_distinct_id = callback => {
  if (!enabled) return
  if (loaded) callback(distinct_id)
  else callbacks_get_distinct_id.push(callback)
}

export const alias = unique_id => {
  get_distinct_id(distinct_id => {
    if (unique_id !== distinct_id) {
      try {
        mixpanel.alias(distinct_id, unique_id)
      }
      catch(e) {
        console.log(`mixpanel.alias exception ${e.message}`)
      }
    }
  })
}

export const people = {
  set: (prop, to, callback) => {
    if (!enabled) return
    try {
      if (debug) console.log(`people set`)
      mixpanel.people.set(prop, to, () => {
        if (debug) console.log(`people.set callback arguments: ${JSON.stringify(arguments)}`)
        if (typeof(callback) === `function`) callback.apply(this, arguments)
      })
    }
    catch(e) {
      console.log(`mixpanel.people.set exception ${e.message}`)
    }
  },
  'set_once': (prop, to, callback) => {
    if (!enabled) return
    try {
      if (debug) console.log(`people set_once`)
      mixpanel.people.set_once(prop, to, () => {
        if (debug) console.log(`people set_once callback arguments: ${JSON.stringify(arguments)}`)
        if (typeof(callback) === `function`) callback.apply(this, arguments)
      })
    }
    catch(e) {
      console.log(`mixpanel.people.set_once exception ${e.message}`)
    }
  },
  increment: (prop, by, callback) => {
    if (!enabled) return
    try {
      mixpanel.people.increment(prop, by, callback)
    }
    catch(e) {
      console.log(`mixpanel.people.increment exception ${e.message}`)
    }
  },
  append: (prop, value, callback) => {
    if (!enabled) return
    try {
      mixpanel.people.append(prop, value, callback)
    }
    catch(e) {
      console.log(`mixpanel.people.append exception ${e.message}`)
    }
  },
  union: (prop, value, callback) => {
    if (!enabled) return
    try {
      mixpanel.people.union(prop, value, callback)
    }
    catch(e) {
      console.log(`mixpanel.people.union exception ${e.message}`)
    }
  },
  charge: (amount, properties, callback) => {
    if (!enabled) return
    try {
      mixpanel.people.charge(amount, properties, callback)
    }
    catch(e) {
      console.log(`mixpanel.people.charge exception ${e.message}`)
    }
  },
  clear_charges: () => {
    if (!enabled) return
    try {
      mixpanel.people.clear_charges()
    }
    catch(e) {
      console.log(`mixpanel.people.clear_charges exception ${e.message}`)
    }
  },
  delete_user: () => {
    if (!enabled) return
    try {
      mixpanel.people.delete_user()
    }
    catch(e) {
      console.log(`mixpanel.people.delete_user exception ${e.message}`)
    }
  },
}

export default {enabled, log_error, set_debug, init, track, time_event, register, register_once, unregister, identify, ignore, unignore, reset, get_distinct_id, alias, people}



// WEBPACK FOOTER //
// ./src/analytics/mixpanel.js